





















import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Prop,
    Vue
} from 'vue-property-decorator';
import {
    HOST
} from "../global";
import {
    pageDataType
} from "../types";
import VuePlyr from 'vue-plyr';
Vue.use(VuePlyr, {
    plyr: {
        fullscreen: {
            enabled: false
        }
    },
    emit: ['ended']
})
@Component
export default class VideoBanner extends Vue {
    @Prop() readonly compData!: any;
    public HOST: string = HOST;
    imageUrl:any = require('../assets/images/Image.png');
    duration: null = null;
    player: null = null;
    // data() {
    //     return {
    //         imageUrl: require('../assets/images/Image.png'),
    //         duration: null,
    //         player: null
    //         // videoUrl: 'https://www.youtube.com/embed/jW4peJBTHcA?start=95&end=1380&version=3&playsinline=1'
    //     }
    // }
    videoTimeUpdated(event: any) {
        this.duration = (this as any).player.currentTime;
        document.querySelector(".plyr__control");
        const overlay =
            (this.$refs.imgoverlay as HTMLElement) ||
            document.querySelector(".img-overlay");
        const text =
            (this.$refs.text as HTMLElement) ||
            document.querySelector(".banner-text");

        // this if statement doesn't seem to do anything
        if ((this as any).player.currentTime < 1) {
            overlay.style.display = 'none';
            text.style.display = 'none';
          //  this.player.stop()
        }
      //  console.log('hello');
    }
    mounted() {
        this.player = (this as any).$refs.player.player;
    }
}
